import { render } from "./ChallengeList.vue?vue&type=template&id=2f1bce72&scoped=true"
import script from "./ChallengeList.vue?vue&type=script&lang=js"
export * from "./ChallengeList.vue?vue&type=script&lang=js"

import "./ChallengeList.vue?vue&type=style&index=0&id=2f1bce72&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f1bce72"]])

export default __exports__